module.exports = __webpack_public_path__ + "static/pathogen-5f824ea9ebf3dc38ad5ab42d514bfddf.png";